import { AxiosResponse } from 'axios';
import { api } from 'src/common/utils';

import { SalesforceAccountType } from '../AccountProfile/types';
import { AccountType, IndustryType, LegalEntityType, ParentAccountType } from '../types';

const ACCOUNTS_ROOT_PATH = 'account_admin';
const PARENT_ACCOUNTS_ROOT_PATH = 'parent_account_admin';
const LEGAL_ENTITIES_ROOT_PATH = 'legal_entities';

export type RequestApiPaginationResponseType<T> = {
  data: {
    count: number;
    next: string;
    previous: string;
    results: T[];
  };
};

type CreateAccountPayloadType = {
  name: string;
  lang: string;
  timezone: string;
  company_industry: string;
  email: string;
  office_phone: string;
  calendar_name: string;
  username: string;
  parent_account: string;
};

export const createAccount = (
  payload: CreateAccountPayloadType
): Promise<AxiosResponse<AccountType>> => api.post(`/${ACCOUNTS_ROOT_PATH}`, payload);

export const fetchIndustry = (): Promise<AxiosResponse<IndustryType[]>> => api.get('/industry');

export const fetchSalesforceAccounts = (
  name: string
): Promise<AxiosResponse<SalesforceAccountType[]>> =>
  api.get(`${ACCOUNTS_ROOT_PATH}/search?name=${name}`);

export const provisionBotNumber = ({ accountId }: { accountId: string }): Promise<AxiosResponse> =>
  api.post(`${ACCOUNTS_ROOT_PATH}/${accountId}/provision_bot_number`);

export const fetchParentAccounts = (name: string): Promise<AxiosResponse<ParentAccountType[]>> =>
  api.get(`${PARENT_ACCOUNTS_ROOT_PATH}?search=${name}`);

export const fetchLegalEntities = (
  name: string
): Promise<RequestApiPaginationResponseType<LegalEntityType>> =>
  api.get(`${LEGAL_ENTITIES_ROOT_PATH}?search=${name}`);
